import React from 'react';
import { useSidebar } from '../../context/SidebarContext';
import { Menu } from 'lucide-react';

export const Header = () => {
    const { openMobile } = useSidebar();

    return (
        <header className="mobile-header">
            <button onClick={openMobile} className="btn-icon" data-testid="mobile-menu-btn">
                <Menu size={20} />
            </button>
            <div className="flex items-center gap-2">
                <img src="/flowbil_512.png" alt="Flowbil" className="w-6 h-6 rounded" />
                <span style={{ fontWeight: 600, fontSize: 14, color: '#0f0f0f' }}>Flowbil</span>
            </div>
            <div style={{ width: 36 }} />
        </header>
    );
};

export default Header;
